import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueTheMask from 'vue-the-mask'
import VueCookies from 'vue-cookies'

Vue.use(VueAxios, axios)
Vue.use(VueTheMask)
Vue.use(VueCookies)

import Cart from './components/Cart.vue'
import Voucher from './components/Voucher.vue'
import AuthButton from './components/AuthButton.vue'
import AuthDialog from './components/AuthDialog.vue'
import Cookies from './components/Cookies.vue'

const websiteapp = new Vue({
    el: '#websiteapp',
    components: {
        Cart,
        Voucher,
        AuthButton,
        AuthDialog,
        Cookies
    },
})
